import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    productVersionTools: [],
  },

  getters: {
    productVersionTools: (state) => {
      return state.productVersionTools;
    },
  },

  actions: {},

  mutations: {
    productVersionTools(state, payload) {
      state.productVersionTools = payload;
    },
  },
});
